import React from 'react';
import { observer } from 'mobx-react';
import { Footer } from '../../../common/footer';
import { HomeNavbar } from '../../../common/home-navbar';
import { Spinner } from '../../../common/spinner';
import { InformationMenu } from '../information-menu';
import { ScreenStore } from '../../../stores/ScreenStore';
import { constants } from '../../../config';
import { routeNaming, AppLink } from '../../../routes';
import { Select } from '../../../common/select';
import { LocationStore } from '../../../stores/LocationStore';
import { enforceDepartments } from '../../../hocs/enforce-departments';
import { ShippingInfoStore } from './stores/ShippingInfoStore';
import { SectionContent } from './section-content';
import styles from './Shipping.css';
import { SEO } from '../../../common/seo';

const Shipping = class Shipping extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      department: null,
      location: null,
    };

    this._updateDepartment = this._updateDepartment.bind(this);
    this._updateLocation = this._updateLocation.bind(this);
  }

  _updateDepartment(department) {
    this.setState({
      department,
    });
    LocationStore.getLocations(department);
  }

  _updateLocation(locationId) {
    this.setState({
      location: locationId,
    });
    ShippingInfoStore.getShipingInfo(locationId);
  }

  render() {
    const haveData = ShippingInfoStore.shippingInfo &&
      Object.keys(ShippingInfoStore.shippingInfo).length > 0;
    const showMobileVersion = ScreenStore.screenWidth <= constants.breakpoints.mobileThreshold;
    const departmentOptions = LocationStore.departments.map(departmentData => ({
      value: departmentData.id,
      label: departmentData.name,
    }));
    const selectedDepartment = departmentOptions.find(department => (
      department.value === this.state.department
    ));
    const locationOptions = (LocationStore.locations || []).map(locationData => ({
      value: locationData.id,
      label: locationData.name,
    }));
    const selectedLocation = locationOptions.find(location => (
      location.value === this.state.location
    ));
    return (
      <div className={styles.container}>
        <SEO
          title="Envíos"
          description="Accede a toda la información relevante sobre Carlos Gutiérrez S.A, nuestros servicios, políticas y cómo podemos ayudarte. Encuentra detalles sobre nuestros productos, condiciones de uso, privacidad, envíos y más. Estamos comprometidos a ofrecerte la mejor experiencia, brindándote transparencia y claridad en todos nuestros procesos. Si tienes preguntas o dudas, esta sección es tu recurso principal para obtener respuestas. Descubre todo lo que necesitas saber y disfruta de una experiencia de compra segura y satisfactoria con nosotros"
          type="website"
        />
        <HomeNavbar />
        <div className={styles.mainWrapper}>
          <div className={styles.mainContent}>
            {showMobileVersion ?
              <p className={styles.breadcrumb}>
                <AppLink
                  className={styles.breadcrumb}
                  routeName={routeNaming.INFORMATION_MENU_MOBILE}
                >
                  Información
                </AppLink>
                <span> &gt; Envíos</span>
              </p>
              : <InformationMenu indexSelectedItem={2} />}
            <div className={styles.bodyContainer}>
              <div className={styles.titleContainer}>
                <h1 className={styles.mainTitle}> Envíos </h1>
              </div>
              <div className={styles.contentContainer}>
                <h2 className={styles.subTitle}>Costos y horarios de envío</h2>
                <p>
                  <b>
                    Selecciona tu departamento y localidad para conocer estimados costos, días
                    y horarios.
                  </b>
                </p>
                <p>
                  Las fechas de envío están sujetas a disponibilidad. Dentro de cada área
                  hay zonas a las que no entregamos.
                </p>
                <div className={styles.selectGroup}>
                  <div
                    className={styles.selectGroupContainer}
                  >
                    <label className={styles.label}>
                      Departamento
                    </label>
                    <Select
                      className={styles.select}
                      onChange={this._updateDepartment}
                      options={departmentOptions}
                      value={selectedDepartment ? selectedDepartment.label : 'Seleccionar'}
                    />
                  </div>
                  <div
                    className={styles.selectGroupContainer}
                  >
                    <label className={styles.label}>
                      Localidad
                    </label>
                    <Select
                      className={styles.select}
                      disabled={!LocationStore.locations}
                      onChange={this._updateLocation}
                      options={locationOptions}
                      value={selectedLocation ? selectedLocation.label : 'Seleccionar'}
                    />
                  </div>
                </div>
                {
                  ShippingInfoStore.loadingShippingInfo &&
                  <Spinner className={styles.spinner} />
                }
                {
                  !!selectedDepartment &&
                  !!selectedLocation &&
                  !ShippingInfoStore.loadingShippingInfo &&
                  !ShippingInfoStore.error &&
                  haveData &&
                  <SectionContent sectionInfo={ShippingInfoStore.shippingInfo} />
                }
                {
                  selectedDepartment && selectedLocation &&
                  !ShippingInfoStore.loadingShippingInfo && !haveData &&
                  <h4>No hay reparto disponible para la localidad seleccionada</h4>
                }
                {
                  !!selectedDepartment && !!selectedLocation &&
                  ShippingInfoStore.error &&
                  <p className={styles.error}>
                    Ha ocurrido un error, por favor intente nuevamente
                  </p>
                }
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div >
    );
  }
};

const ObservedShipping = enforceDepartments(observer(Shipping));

export { ObservedShipping as Shipping };



// WEBPACK FOOTER //
// ./src/pages/information/shipping/Shipping.jsx